module.exports = __webpack_public_path__ + "static/media/User.27261b9e.svg";